export default __webpack_public_path__ + "img/right2.faf291a3.jpg";